"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_final_form_1 = require("react-final-form");
const react_1 = __importStar(require("react"));
const Context = (0, react_1.createContext)(null);
const WizardForm = (props) => {
    const { children, onSubmit, ...rest } = props;
    const forms = Array.isArray(children) ? children : [children];
    const [page, setPage] = (0, react_1.useState)(0);
    (0, react_1.useEffect)(() => {
        props.onPageChange && props.onPageChange(page);
    }, [page]);
    const nextPage = () => setPage(page + 1);
    const handlePrevClick = () => page > 0 && setPage(page - 1);
    const isLastStep = forms.length - 1 === page;
    const activeStep = forms[page];
    const handleSubmit = (0, react_1.useCallback)((...args) => {
        const submit = isLastStep ? onSubmit : nextPage;
        // @ts-ignore
        const { onSubmit: stepOnSubmit } = activeStep.props;
        if (stepOnSubmit) {
            // @ts-ignore
            return stepOnSubmit(...args).then(() => submit(...args));
        }
        return submit(...args);
    }, [activeStep, isLastStep]);
    return (react_1.default.createElement(react_final_form_1.Form, { onSubmit: handleSubmit, ...rest }, (renderProps) => (react_1.default.createElement(Context.Provider, { value: {
            ...renderProps,
            handlePrevClick,
            steps: { current: page, count: forms.length },
        } }, activeStep))));
};
WizardForm.Step = Step;
function Step({ children }) {
    const renderProps = (0, react_1.useContext)(Context);
    if (!renderProps) {
        return null;
    }
    return typeof children === 'function' ? children(renderProps) : children;
}
exports.default = WizardForm;
